import React from 'react';
import Pagination from 'partial/components/Pagination';
import Table from 'partial/components/Table';
import { useReportsContext } from 'partial/wrappers/ReportsContext';
import dayjs from 'dayjs';
import Badges from 'modules/common/components/Badge';
import { upperCase } from 'lodash';

const format = [
  {
    label: 'REGISTRATION DATE',
    id: 'date',
    key: ({ created_at }) => (
      <span>{dayjs(created_at).format('MMM DD, YYYY hh:mm A')}</span>
    ),
  },
  { label: 'AGENCY NAME', key: 'name' },
  { label: 'REMARKS', key: 'remarks' },
  {
    id: 'status',
    key: ({ status }) => (
      <Badges
        status={upperCase(status)}
        containerClassName="!text-xs !px-4 w-[120px]"
      />
    ),
    labelClassName: 'px-[24px] md:!px-11 whitespace-nowrap flex justify-end',
    contentClassName: 'px-[24px] md:!px-11 whitespace-nowrap flex justify-end',
    label: 'STATUS',
  },
];

export default function RegistrationList() {
  const { isLoading, list, meta, setPage } = useReportsContext();

  return (
    <div className="flex flex-col gap-10 min-h-[65vh]">
      <Table isLoading={isLoading} data={list} format={format} />
      {!isLoading && <Pagination value={meta} onChange={setPage} />}
    </div>
  );
}
